export default "__VITE_PUBLIC_ASSET__946b1e64__"